import { render, staticRenderFns } from "./ShowTitleAndModify.vue?vue&type=template&id=59566cb6"
import script from "./ShowTitleAndModify.vue?vue&type=script&lang=js"
export * from "./ShowTitleAndModify.vue?vue&type=script&lang=js"
import style0 from "./ShowTitleAndModify.vue?vue&type=style&index=0&id=59566cb6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports